/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBluetooth = createReactComponent("outline", "bluetooth", "IconBluetooth", [["path", { "d": "M7 8l10 8l-5 4l0 -16l5 4l-10 8", "key": "svg-0" }]]);

export { IconBluetooth as default };
//# sourceMappingURL=IconBluetooth.mjs.map
